import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class ServiceApi {


    static getServices = async (response, error) => {
        await Api.get(`${configs.service.service}`, null, response, UserApi.getAuthorizedHeader(), error);

    }
    static getService = async (id,response, error) => {
        await Api.get(`${configs.service.service}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);

    }


    static insertServices = async (data, response, error) => {
        await Api.post(`${configs.service.service}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static updateServices = async (data, id, response, error) => {
        await Api.put(`${configs.service.service}/${id}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static deleteServices = async (id, response, error) => {
        await Api.delete(`${configs.service.service}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

}